// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import { rugPopupStyles } from "@rugby/App/Components/Tippy/Style";
import { SearchInputStyles } from "@rugby/Overrides/Widgets/Header/SearchInput";
import { constants } from "@rugby/XDL/constants";
import { screen } from "@rugby/XDL/Helpers";
import Search from "@rugby/XDL/Icons/Search";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { styledScrollbar } from "@rugby/XDL/Utilities/SharedStyles";
import { css } from "styled-components";

const commonLinkStyles: LinkPresentationProps = {
    color: "secondary",
    typographyProps: {
        size: 15,
        ellipsis: true,
        css: css`
            font-weight: bold;
            letter-spacing: 0;
            line-height: 18px;
            width: 100%;
            text-align: left;
            margin: 8px 0;
        `,
    },
    css: css`
        width: auto;
        overflow: hidden;
    `,
};

export const customSearchInputStyles: SearchInputStyles = {
    input: {
        sizeVariant: "default",
        iconProps: { src: Search, color: "text.link" },
        cssOverrides: {
            formField: css`
                width: 350px;
                @media (max-width: ${constants.header.breakPoints.md}px) {
                    width: 100%;
                }
            `,
            inputSelect: css`
                background: ${getColor("common.white")};
                color: ${getColor("text.main")};

                // to keep search icon without overlapping a text
                &,
                &:focus {
                    padding: 0 35px 0 10px;
                }
            `,
        },
    },
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            display: inline-flex;
            justify-content: flex-end;
        `,
    },
    popoverContentBody: {
        as: "div",
        _height: "100%",
    },
    autocompleteWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            overflow-y: auto;

            max-height: 680px;
            ${styledScrollbar()}

            ${MediaQuery.lte("lg")} {
                padding: 15px 8px;
                max-height: 380px;
            }

            ${MediaQuery.lte("md")} {
                flex-direction: column;
            }
        `,
    },
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 375px;
            padding: 0 20px 15px 20px;
            b {
                font-weight: normal;
            }
        `,
    },
    autocompleteProductsColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: auto;
            padding: 0 20px 15px 20px;

            ${screen("gt", "md")`
                width: 780px;
            `}
        `,
    },
    autocompleteCategoriesStyles: {
        headerText: {
            color: "text.main",
            size: 22,
            weight: "normal",
            css: css`
                border-bottom: 2px solid ${getColor("common.border")};
                padding-bottom: 10px;
                text-align: left;
                line-height: 26px;
                margin-bottom: 24px;
            `,
        },
        link: commonLinkStyles,
    },
    autocompleteBrandsStyles: { link: commonLinkStyles },
    autocompleteContentStyles: { link: commonLinkStyles },
    tippyStyle: {
        closeButton: {
            ...rugPopupStyles.closeButton,
            css: css`
                ${rugPopupStyles.closeButton.css}
                top: 8px;

                ${MediaQuery.lte("md")} {
                    top: 10px;
                    right: 10px;
                }
            `,
        },
    },
};
